module EnvironmentVariables {
    import AllEnvironmentNames = Shared.Environments.IAllEnvironmentNames;
    module.factory("EnvironmentVariablesService", [
        "$http",
        "BootstrapDataService",
        function ($http, bootstrapDataService) {
            return {
                getEnvironmentVariables: function () {
                    return $http.get(bootstrapDataService.getEnvironmentVariablesUrl);
                },
                saveEnvironmentVariables: function (jsonString, version) {
                    return $http.post(bootstrapDataService.getEnvironmentVariablesUrl, { environmentVariables: jsonString, version: version });
                },
                getEnvironmentWithDisplayName: function() : AllEnvironmentNames {
                    return $http.get(bootstrapDataService.getEnvironmentWithDisplayName);
                },
            };
        }
    ]).factory("DataTypeService", [function () {
        return {
            getType: function (value) {
                if (value === undefined || value === null || value === NaN) {
                    return "Invalid";
                }

                var constructor = value.constructor;
                if (constructor === String) {
                    return "String";
                }
                else if (constructor === Number) {
                    return "Number";
                }
                else if (constructor === Boolean) {
                    return "Boolean";
                }
                else if (constructor === Array) {
                    return "Array";
                }
                else if (constructor === Object) {
                    if (value.__frends_isSecret) {
                        return "Secret";
                    }
                    return "Object";
                } else {
                    return "Invalid";
                }
            },
            dataTypes: [
                { typeName: "String", displayName: FRENDS.Localizations.EnvironmentVariables_DatatypeText, getDefaultValue: function () { return ""; } },
                { typeName: "Secret", displayName: FRENDS.Localizations.EnvironmentVariables_DatatypeSecret, getDefaultValue: function () {return { __frends_isSecret: true, isDirty: true, value: "" } } },
                { typeName: "Number", displayName: FRENDS.Localizations.EnvironmentVariables_DatatypeNumber, getDefaultValue: function () { return 0; } },
                { typeName: "Boolean", displayName: FRENDS.Localizations.EnvironmentVariables_DatatypeYesNo, getDefaultValue: function () { return false; } },
                { typeName: "Array", displayName: FRENDS.Localizations.EnvironmentVariables_DatatypeList, getDefaultValue: function () { return []; } },
                { typeName: "Object", displayName: FRENDS.Localizations.EnvironmentVariables_DatatypeGroup, getDefaultValue: function () { return {}; } }
            ]
        };
    }]);
}